import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { Button, space, device } from '@ticketswap/solar'
import { useQuery } from '@apollo/react-hooks'
import GET_VIEWER_PARTNER from './isViewerPartner'
import PartnerDialog from '~/components/PartnerDialog'
import PropTypes from 'prop-types'
import { Description, StyledCover, Title } from '~/components/BlobCover/styles'
import { NarrowPageLayout } from '~/components/PageLayout'

const StyledButton = styled(Button)`
  align-self: flex-end;
  margin: 0 auto;
  display: inline-flex;
  clear: both;
  ${({ type }) =>
    type !== 'default' &&
    css`
      background-color: rgb(0, 83, 111);
      background-image: none;

      &:hover {
        background-color: rgb(0, 102, 137);
      }
    `}
  
  ${({ type }) =>
    type === 'transformed' &&
    css`
      transform: translateY(40%);

      @media ${device.tablet} {
        padding: 16px 90px;
      }
    `}
    
   ${({ type }) =>
     type === 'bordered' &&
     css`
       @media ${device.tablet} {
         padding: 16px 90px;
       }

       &:before {
         content: '';
         position: absolute;
         width: calc(100% + ${space[16]});
         height: calc(100% + ${space[16]});
         top: -${space[8]};
         left: -${space[8]};
         border: ${space[8]} solid white;
         pointer-events: none;
       }
     `}
     
     ${({ type }) =>
       type === undefined &&
       css`
         @media ${device.tablet} {
           padding: 16px 90px;
         }
       `}
`

export const BecomePartnerButton = ({
  t,
  width,
  size,
  type,
  variant,
  viewerIsPartner = false,
  loggedIn = false,
}) => {
  const { data = {} } = useQuery(GET_VIEWER_PARTNER, {
    skip: viewerIsPartner || !loggedIn,
  })
  const { viewer = {} } = data
  const { isPartner = viewerIsPartner } = viewer

  return (
    <>
      {isPartner && (
        <StyledButton
          as="a"
          href="/organizers/dashboard"
          type={type}
          onClick={() => (window.location.href = '/organizers/dashboard')}
          variant={variant}
        >
          {t('partners:header.button.dashboard')}
        </StyledButton>
      )}
      {!isPartner && (
        <PartnerDialog t={t}>
          {({ getToggleProps }) => (
            <StyledButton
              type={type}
              variant={variant}
              width={width}
              size={size}
              {...getToggleProps()}
            >
              {t('partners:header.button.becomePartner')}
            </StyledButton>
          )}
        </PartnerDialog>
      )}
    </>
  )
}
BecomePartnerButton.propTypes = {
  t: PropTypes.func.isRequired,
  width: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string,
  viewerIsPartner: PropTypes.bool,
}

export const PartnerCover = ({ t, viewerIsPartner }) => {
  return (
    <StyledCover>
      <NarrowPageLayout>
        <Title>{t('partners:header.title')}</Title>
        <Description>{t('partners:header.description')}</Description>
      </NarrowPageLayout>
      <BecomePartnerButton
        viewerIsPartner={viewerIsPartner}
        type={'transformed'}
        t={t}
      />
    </StyledCover>
  )
}

PartnerCover.propTypes = {
  t: PropTypes.func.isRequired,
  viewerIsPartner: PropTypes.bool,
}
